import React, { useEffect, useState } from 'react';
import classes from "./CommunicationWidgetBox.module.scss";
import MessageBox from "../../page/messenger/MessageBox/MessageBox";
import axios from "axios";
import { boxiPrimary, boxiRed } from "../../../assets/style/colors";
import { Spinner } from "reactstrap";
import io from 'socket.io-client';
import { useToastContext } from "../../../wrappers/ToastContext";
import newMessageSound from '../../../assets/notification.wav';




// const socketLocal = io("http://localhost:5000");
// const socketRemote = io("https://dev-api.boxi.co");

const socketLocal = io(process.env.REACT_APP_API_HOST);
const socketRemote = io(process.env.REACT_APP_API_HOST);

const CommunicationWidgetBox = ({ nameOfVendor, phoneNumber, vendorID }) => {
  const { toast } = useToastContext();

  const [listingOffset, setListingOffset] = useState(0);
  const [paginationStatus, setPaginationStatus] = useState(0);

  const [threadListingOffset, setThreadListingOffset] = useState(0);
  const [threadPaginationStatus, setThreadPaginationStatus] = useState(0);
  const [threadMessagesCount, setThreadsMessagesCount] = useState(0);

  const [selectedVendor, setSelectedVendor] = useState(null);
  const [currentChat, setCurrentChat] = useState([]);
  const [isCurrentChatBlocked, setIsCurrentChatBlocked] = useState(false)
  const [isCurrentChatPictureBlast, setIsCurrentChatPictureBlast] = useState(false)

  const [isSelectedChatLoading, setSelectedChatLoading] = useState(true);


  const [vendorName, setVendorName] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  const [pictureBlastVendorList, setPictureBlastVendorList] = useState([])

  const [shouldScrollDown, setShouldScrollDown] = useState(false);

  const audio = new Audio(newMessageSound);

  // Hook is excuted to make initial call for getting chats of the vendor
   useEffect(() => {
    if(selectedVendor == null){
      setVendorId(vendorID);
      getChat(vendorID, formatPhoneNumberToE164(phoneNumber))
    }

}, [threadListingOffset])

useEffect(() => {
  if (threadListingOffset > 0 && threadPaginationStatus === 0) getChat(selectedVendor.vendor_id, selectedVendor.phone_number);
  else if (threadListingOffset === 0 && threadPaginationStatus === 1) getChat(selectedVendor.vendor_id, selectedVendor.phone_number);
}, [threadListingOffset, threadPaginationStatus])

useEffect(() => {
  const handleMsgReceivedInOpenThread = async (data) => {
    setShouldScrollDown(true);
    setThreadListingOffset(0);
    setThreadPaginationStatus(1);
    // await getChat(selectedVendor?.vendor_id, selectedVendor?.phone_number);
    // setPaginationStatus(3);
    // await getChats();
    toast.success(data);
    await audio.play();
  };
  
  const handleMsgReceived = async (data) => {
    setPaginationStatus(3);
    // await getChats();
    toast.success(data);
    await audio.play();
  };
  
  
  const handleMsgSentSuccessInOpenThread = async () => {
    setShouldScrollDown(true);
    setThreadListingOffset(0);
    setThreadPaginationStatus(1);
    // await getChat(selectedVendor.vendor_id, selectedVendor.phone_number);
  };
  
  const handleMsgSentSuccess = async () => {
    setPaginationStatus(3);
    // await getChats();
  };
  
  if (selectedVendor) {
    socketRemote.on('msgReceived', handleMsgReceivedInOpenThread);
    socketLocal.on('msgSentSuccess', handleMsgSentSuccessInOpenThread);
  } else {
    socketRemote.on('msgReceived', handleMsgReceived);
    socketLocal.on('msgSentSuccess', handleMsgSentSuccess);
  }

  return () => {
    setPictureBlastVendorList([])
    socketRemote.off('msgReceived', handleMsgReceivedInOpenThread);
    socketRemote.off('msgReceived', handleMsgReceived);
    socketLocal.off('msgSentSuccess', handleMsgSentSuccessInOpenThread);
    socketLocal.off('msgSentSuccess', handleMsgSentSuccess);
  };
}, [selectedVendor]);


  // Method use to Change Phone Formate to make api call
  const formatPhoneNumberToE164 = (phoneNumber) => {
    if (phoneNumber !== '') {
      const numericPhoneNumber = phoneNumber.replace(/\D/g, '');
      return numericPhoneNumber.length === 10 ? `+1${numericPhoneNumber}` : `+${numericPhoneNumber}`;
    }
  }

  // Method to get chat of the respective Vendor on basis of the Phone Number
  const getChat = async (vendor_id, phone_number, initialCall) => {
    try {
      if (phone_number) {
        if (initialCall || phone_number !== selectedVendor?.phone_number) {
          setSelectedChatLoading(true);
          setCurrentChat([]);
          setThreadListingOffset(0);
          setThreadsMessagesCount(0);
        }
        setSelectedVendor({vendor_id, phone_number});
        const params = {
          page: initialCall ? 0 : threadListingOffset,
          paginationStatus: threadPaginationStatus,
          from: 'web'
        }

        const _chat = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/chat/${phone_number}`, { params });
        
        setCurrentChat(initialCall || threadPaginationStatus === 1 ? _chat?.data?.chat : [...currentChat, ..._chat?.data?.chat]);
        if (threadPaginationStatus === 1) setThreadPaginationStatus(0)
        
        if (selectedVendor) setPaginationStatus(3);

        setThreadsMessagesCount(+_chat.data.total);
        setSelectedChatLoading(false);
      }
    } catch (error) {
      console.error(error);
      setSelectedChatLoading(false);
    } 
  }


  return (
    <div className={classes.container}>
      {<section>
        {(isSelectedChatLoading == false && currentChat.length !==0 ) &&   <MessageBox
          pictureBlastVendorList={pictureBlastVendorList}
          className={classes['custom-scroll']}
          messages={currentChat}
          selectedVendor={selectedVendor}
          setIsCurrentChatPictureBlast={setIsCurrentChatPictureBlast}
          vendorName={nameOfVendor}
          vendorId={vendorId}
          isLoading={isSelectedChatLoading}
          isCurrentChatBlocked={isCurrentChatBlocked}
          isCurrentChatPictureBlast={isCurrentChatPictureBlast}
          threadMessagesCount={threadMessagesCount}
          threadListingOffset={threadListingOffset}
          setThreadListingOffset={setThreadListingOffset}
          threadPaginationStatus={threadPaginationStatus}
          setThreadPaginationStatus={setThreadPaginationStatus}
          shouldScrollDown={shouldScrollDown}
          setShouldScrollDown={setShouldScrollDown}
          asAWidget={true}
          vendorPhoneNumber={formatPhoneNumberToE164(phoneNumber)}
                  />   }

        { isSelectedChatLoading && <div className={classes.spinner}>
            <Spinner style={{color: boxiPrimary}}></Spinner>
            <div>Loading Messages...</div>
          </div>}

          { (isSelectedChatLoading == false && currentChat.length ==0 ) &&<div className={classes.navigationButton}>
          {/* Button to start new communication*/}
          <a 
          href={`/dashboard/admin/communication/`} 
          rel="noopener noreferrer" 
          style={{ 
            textDecoration: 'none',
            color: 'white', // Set text color to white
            backgroundColor: '#B93A76', // Set background color to red
            borderRadius: '15px', // Set border radius to make background rounded
            padding: '5px 10px', // Add some padding for better visual appearance
            display: 'inline-block' // This makes the padding and borderRadius effective
          }}
        >
          {"Compose Message"}
        </a>
        </div>}
        
      </section>}
    </div>
  );
}

export default CommunicationWidgetBox;
